import { type ReactNode } from 'react';

import { TooltipProvider } from '@ctct/payflow-ui';
import { SpinnerOverlay } from '@ctct/presentation-layer';

import { OrderSummaryWidgetContent } from './OrderSummaryWidgetContent';
import './order-summary-widget.scss';
import type { useOrderSummaryWidget } from './useOrderSummaryWidget';

type Props = ReturnType<typeof useOrderSummaryWidget> & {
  injectedMiddleComponent?: ReactNode;
  hideHeading?: boolean;
};

export const OrderSummaryWidget = ({
  status,
  hooks,
  data,
  externalHooks,
  handlers,
  injectedMiddleComponent,
  hideHeading = false,
}: Props) => {
  const hasPendingExternalRedirect = externalHooks.useHasPendingExternalRedirect();

  return (
    <TooltipProvider>
      <div className="order-summary-widget">
        <SpinnerOverlay
          isLoading={status === 'pending' || (status === 'loaded' && hasPendingExternalRedirect)}
          a11yLabel={data.getCopies().loadSpinner}
        >
          <OrderSummaryWidgetContent
            data={data}
            handlers={handlers}
            hooks={hooks}
            injectedMiddleComponent={injectedMiddleComponent}
            hideHeading={hideHeading}
          />
        </SpinnerOverlay>
      </div>
    </TooltipProvider>
  );
};
